import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col px-2 pb-2 gap-3 bg-gray-100 rounded-lg border border-gray-200 shadow-sm" }
const _hoisted_2 = { class: "flex flex-col gap-2 p-2 bg-white rounded-md shadow-sm" }
const _hoisted_3 = ["onMouseover", "onMouseleave"]
const _hoisted_4 = { class: "flex-1 min-w-0 flex flex-col gap-0.5" }
const _hoisted_5 = { class: "text-gray-700 font-semibold truncate" }
const _hoisted_6 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_7 = { class: "flex flex-wrap gap-2 mt-0.5" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "filter-value"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "filter-value"
}
const _hoisted_12 = {
  key: 0,
  class: "filter-value"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 2,
  class: "filter-value"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 2,
  class: "filter-value"
}
const _hoisted_17 = {
  key: 0,
  class: "flex gap-2 items-center flex-shrink-0 ml-2 mt-1",
  style: {"max-width":"48px"}
}
const _hoisted_18 = { class: "flex justify-between" }

import { computed, ref } from "vue"
import GgmsChip from "@/components/GgmsChip.vue"
import { Filter } from "@/shared/models/filter"
import { displayFilterValue, displayFilterRule } from "@/shared/utils/helpers"
import { PencilIcon, TrashIcon } from "@heroicons/vue/outline"
import { useTagStore } from "@/stores/tag"
import { useOriginStore } from "@/stores/origin"
import { useLandingPageGroupStore } from "@/stores/landing-page-group"

interface Props {
    groupIndex: number
    filters: Filter[]
    groupsLength: number
    justDisplay?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterGroup',
  props: {
    groupIndex: {},
    filters: {},
    groupsLength: {},
    justDisplay: { type: Boolean, default: false }
  },
  emits: ["removeGroup", "addNewFilterToGroup", "editFilter", "removeFilter"],
  setup(__props: any, { emit: __emit }) {

const tagStore = useTagStore()
const originStore = useOriginStore()
const landingPageGroupStore = useLandingPageGroupStore()

const props = __props
const emit = __emit

const iconVisibility = ref(new Array(props.filters.length).fill(false))

const isOnlyOneGroup = computed(() => props.groupsLength === 1)
const cachedTags = computed(() => tagStore.cachedTags)
const cachedOrigins = computed(() => originStore.cachedOrigins)
const cachedLandingPageGroups = computed(() => landingPageGroupStore.cachedGroups)

function getTagsByFilterIds(filter: Filter) {
    return tagStore.tableState.data.filter((tag) => (filter.value as string[])?.includes(tag._id))
}

function getOriginsByFilterIds(filter: Filter) {
    return originStore.tableState.data.filter((origin) => (filter.value as string[])?.includes(origin._id))
}

function shouldFormatTime(displayName?: string) {
    return [
        "Due Date & Time",
        "Last Updated At",
        "Created At",
        "Last Sent Email",
        "Last Email",
        "Last Received Email",
        "Last Call Made",
        "Last Call",
        "Last Call Received",
        "Last Sent Text",
        "Last Text",
        "Last Received Text",
        "Last Communication",
        "Sent at",
        "Last Run At",
        "Last Updated At",
    ].includes(displayName ?? "")
}

function getLandingPageGroupsByFilterIds(filter: Filter) {
    return landingPageGroupStore.tableState.data.filter((group) => (filter.value as string[])?.includes(group._id))
}

function removeGroup() {
    emit("removeGroup", props.groupIndex)
}

function addNewFilterToGroup() {
    emit("addNewFilterToGroup", props.groupIndex)
}

function removeFilter(filterIndex: number) {
    emit("removeFilter", props.groupIndex, filterIndex)
}

function editFilter(filter: Filter, filterIndex: number) {
    emit("editFilter", filter, props.groupIndex, filterIndex)
}

function setIconVisibility(filterIndex: number, isVisible: boolean) {
    iconVisibility.value[filterIndex] = isVisible
}

function checkIsArray(value?: string | string[] | Date) {
    return Array.isArray(value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex justify-between px-2 text-gray-500" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter, filterIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: filter.field,
          class: "flex-nowrap flex items-start justify-between text-sm cursor-pointer hover:bg-gray-100 rounded-md px-2 py-1 min-w-0 w-full",
          onMouseover: ($event: any) => (setIconVisibility(filterIndex, true)),
          onMouseleave: ($event: any) => (setIconVisibility(filterIndex, false))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(filter.displayName), 1),
            (filter.field !== 'doNotDisturb')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(displayFilterRule)(filter.rule)), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              (filter.displayName === 'Tags')
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(getTagsByFilterIds(filter), (tag) => {
                    return (_openBlock(), _createBlock(GgmsChip, {
                      key: tag._id,
                      bgColor: cachedTags.value[tag._id]?.backgroundColor,
                      textColor: cachedTags.value[tag._id]?.foregroundColor,
                      isRemovable: false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tag.displayName), 1)
                      ]),
                      _: 2
                    }, 1032, ["bgColor", "textColor"]))
                  }), 128))
                : (filter.displayName === 'Origins')
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(getOriginsByFilterIds(filter), (origin) => {
                      return (_openBlock(), _createBlock(GgmsChip, {
                        key: origin._id,
                        bgColor: cachedOrigins.value[origin._id]?.backgroundColor,
                        textColor: cachedOrigins.value[origin._id]?.foregroundColor,
                        isRemovable: false
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(origin.displayName), 1)
                        ]),
                        _: 2
                      }, 1032, ["bgColor", "textColor"]))
                    }), 128))
                  : (filter.displayName === 'Groups')
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(getLandingPageGroupsByFilterIds(filter), (group) => {
                        return (_openBlock(), _createBlock(GgmsChip, {
                          key: group._id,
                          bgColor: cachedLandingPageGroups.value[group._id]?.backgroundColor,
                          textColor: cachedLandingPageGroups.value[group._id]?.foregroundColor,
                          isRemovable: false
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(group.displayName), 1)
                          ]),
                          _: 2
                        }, 1032, ["bgColor", "textColor"]))
                      }), 128))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (checkIsArray(filter.value))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                              (filter.type === 'Date')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (filter.value[0])
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(displayFilterValue)(
                                            filter.value[0],
                                            filter.field,
                                            true,
                                            shouldFormatTime(filter.displayName)
                                        )), 1))
                                      : _createCommentVNode("", true),
                                    (filter.value[0] && filter.value[1])
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, " - "))
                                      : _createCommentVNode("", true),
                                    (filter.value[1])
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(displayFilterValue)(
                                            filter.value[1],
                                            filter.field,
                                            true,
                                            shouldFormatTime(filter.displayName)
                                        )), 1))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (filter.rule === 'isBetween')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      (filter.value[0])
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(displayFilterValue)(filter.value[0], filter.field)), 1))
                                        : _createCommentVNode("", true),
                                      (filter.value[0] && filter.value[1])
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "- "))
                                        : _createCommentVNode("", true),
                                      (filter.value[1])
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(displayFilterValue)(filter.value[1], filter.field)), 1))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(filter.value, (value, index) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: index,
                                        class: "filter-value"
                                      }, _toDisplayString(_unref(displayFilterValue)(value, filter.field)), 1))
                                    }), 128))
                            ]))
                          : (filter.field === 'doNotDisturb')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(filter.value ? "is enabled" : "is not enabled"), 1))
                            : (filter.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(displayFilterValue)(
                                        Array.isArray(filter.value) ? String(filter.value[0]) : String(filter.value),
                                        filter.field,
                                        filter.type === "Date",
                                        shouldFormatTime(filter.displayName),
                                        ["type", "typeName"].includes(filter.field),
                                        filter.rule === "isIn",
                                        filter.field === "reminder"
                                    )), 1))
                              : _createCommentVNode("", true)
                      ], 64))
            ])
          ]),
          (iconVisibility.value[filterIndex] && !_ctx.justDisplay)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_unref(PencilIcon), {
                  class: "h-5 w-5 text-gray-400 hover:text-gray-500",
                  onClick: _withModifiers(($event: any) => (editFilter(filter, filterIndex)), ["prevent","stop"])
                }, null, 8, ["onClick"]),
                (_ctx.filters.length > 1)
                  ? (_openBlock(), _createBlock(_unref(TrashIcon), {
                      key: 0,
                      class: "h-5 w-5 text-gray-400 hover:text-gray-500",
                      onClick: _withModifiers(($event: any) => (removeFilter(filterIndex)), ["prevent","stop"])
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 40, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_18, [
      (!_ctx.justDisplay)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "px-2 bg-primary-color-600 text-white rounded w-fit cursor-pointer",
            onClick: _withModifiers(addNewFilterToGroup, ["stop"])
          }, " AND "))
        : _createCommentVNode("", true),
      (!isOnlyOneGroup.value && !_ctx.justDisplay)
        ? (_openBlock(), _createBlock(_unref(TrashIcon), {
            key: 1,
            class: "h-5 w-5 text-gray-400 hover:text-gray-500 cursor-pointer",
            onClick: _withModifiers(removeGroup, ["stop"])
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})